
let TireBrandLogo = (() => {
    let init = (tireBrandOptions) => {
        const storeBrand = Util.lookupInternalBrandIds(Util.getCookie('brand_id'));
        const s3ImageUrl = Util.s3ImageUrl;
        jQuery.ajax({
            url: `${Util.lambdaHost}/tirebrands`,
            type: 'GET',
            headers: {
                'x-api-key': Util.lambdaApiKey
            }
        }).done((tireBrandData) => {
            filteredTireBrandData = tireBrandData.filter((entry) => {
                if (entry.TireMake !== "Falken" && entry.TireMake !== "Hercules" && entry.TireMake !== "Hi-Run") {
                    let tireMake = entry.TireMake.replace(' ', '-').toLowerCase();
                    return entry.BrandID === storeBrand && tireBrandOptions[tireMake].visibility === "visible";
                }
            });

            filteredTireBrandData.sort((tireBrandA, tireBrandB) => {
                let tireBrandNameA = tireBrandA.TireMake.replace(' ', '-').toLowerCase();
                let tireBrandNameB = tireBrandB.TireMake.replace(' ', '-').toLowerCase();

                let optionsA = tireBrandOptions[tireBrandNameA];
                let optionsB = tireBrandOptions[tireBrandNameB];

                return parseInt(optionsA.sort_order) - parseInt(optionsB.sort_order);
            });

            let tireBrandHTML = "";
            filteredTireBrandData.forEach((tire_brand) => {
                let logoTitle = `TireBrand_Logo_${tire_brand.TireMake}`;
                tireBrandHTML += `
                <a href="/tiremake/${tire_brand.TireMake.replace(' ', '-').toLowerCase()}">
                    <img src="${s3ImageUrl}Tire_Brand_Images/${logoTitle}.png" alt="${tire_brand.TireMake} logo">
                </a>`;
            });

            jQuery("#tire-brand-logo-wrapper").append(tireBrandHTML);
        });
    }

    return {
        init: init
    }
})();